import React from 'react';

export const LanguageContext = React.createContext({
    lang: 'pl', // default language
    setLang: (lang: string) => {},
});
